/** Current profile session mode */
export enum SessionModeEnum {
  /** Tenant mode (users only) */
  TENANT = 'TENANT',
  /** Personal account mode (users, external users) */
  PERSONAL_ACCOUNT = 'PERSONAL_ACCOUNT',
  /** Profile personal page (profile only) */
  PROFILE = 'PROFILE',
}
